import Maybe from 'data.maybe'
import util from '@/libs/util'
import * as R from 'ramda'

const nothingIs = R.ifElse(R.__, Maybe.Nothing, Maybe.Just)
const nothingIsNil = nothingIs(R.isNil)
const nothingIsEmpnil = nothingIs(util.isEmpnil)
const of = (o) => Maybe.of(o).chain(nothingIsNil)
const prop = (prop) => (o) => nothingIsNil(R.prop(prop, o))
const path = (path) => (o) => nothingIsEmpnil(R.path(path, o))

export { of, prop, path, nothingIs, nothingIsNil, nothingIsEmpnil }
